module.exports = __webpack_public_path__ + "img/banner1@2x.e95685a2.png";